/* tslint:disable */
/* eslint-disable */
/**
 * Plateformes API
 * API for managing plateformes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Corporate PersonneMorale tied to an OrganizationUnit. Used to pre-fill the default subscriber
 * when creating a collective contract for that plateforme.
 * 
 * @export
 * @interface PlateformeCorporatePersonneMoraleDto
 */
export interface PlateformeCorporatePersonneMoraleDto {
    /**
     * 
     * @type {string}
     * @memberof PlateformeCorporatePersonneMoraleDto
     */
    plateformeId: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeCorporatePersonneMoraleDto
     */
    personneMoraleId: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeCorporatePersonneMoraleDto
     */
    designation: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeCorporatePersonneMoraleDto
     */
    siret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlateformeCorporatePersonneMoraleDto
     */
    email?: string | null;
}

/**
 * Check if a given object implements the PlateformeCorporatePersonneMoraleDto interface.
 */
export function instanceOfPlateformeCorporatePersonneMoraleDto(value: object): value is PlateformeCorporatePersonneMoraleDto {
    if (!('plateformeId' in value) || value['plateformeId'] === undefined) return false;
    if (!('personneMoraleId' in value) || value['personneMoraleId'] === undefined) return false;
    if (!('designation' in value) || value['designation'] === undefined) return false;
    return true;
}

export function PlateformeCorporatePersonneMoraleDtoFromJSON(json: any): PlateformeCorporatePersonneMoraleDto {
    return PlateformeCorporatePersonneMoraleDtoFromJSONTyped(json, false);
}

export function PlateformeCorporatePersonneMoraleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlateformeCorporatePersonneMoraleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plateformeId': json['plateformeId'],
        'personneMoraleId': json['personneMoraleId'],
        'designation': json['designation'],
        'siret': json['siret'] == null ? undefined : json['siret'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function PlateformeCorporatePersonneMoraleDtoToJSON(json: any): PlateformeCorporatePersonneMoraleDto {
    return PlateformeCorporatePersonneMoraleDtoToJSONTyped(json, false);
}

export function PlateformeCorporatePersonneMoraleDtoToJSONTyped(value?: PlateformeCorporatePersonneMoraleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plateformeId': value['plateformeId'],
        'personneMoraleId': value['personneMoraleId'],
        'designation': value['designation'],
        'siret': value['siret'],
        'email': value['email'],
    };
}

